
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LanguageIcon from '@mui/icons-material/Language';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { Snowshoeing } from '@mui/icons-material';
import StyleIcon from '@mui/icons-material/Style';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import TtkList from './TtkList';
const ChoreographerTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of Services:</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <StyleIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Choreographer Style :</b>&nbsp;<TtkList data={data?.choreographerStyle} /></p>
                        </div>


                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <AutoFixHighIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Where do You Provide Training Session ? :</b>&nbsp;<TtkList data={data?.performancePreference} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price :</b>&nbsp;<span>&#8377; {data?.price}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <Snowshoeing sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Do You Provide Back Dancers ? :</b>&nbsp;{data?.backDancers}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChoreographerTTK